export default {
  noDataDescription: 'Keine Daten im ausgewählten Zeitraum verfügbar.',
};
